// extracted by mini-css-extract-plugin
export var divider = "_1u-0";
export var dividerText = "_1u-2";
export var dividerVertical = "_1u-1";